
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefit/affiliate",
      function () {
        return require("private-next-pages/benefit/affiliate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefit/affiliate"])
      });
    }
  